import { useEffect, useState } from "react";
import { KeywordsTransport } from "src/app/transports/keywords";
import { TLangType } from "src/app/types/LangType";
import { TContentType } from "src/app/types/orders/order";

export interface ICurrentValues {
    thematicId?: number;
    contentType?: TContentType;
    wordCount?: number;
    title?: string;
    orderId?: number;
    rdId?: number;
}
const useAskJarvisForMT = (
    thematicId?: number,
    lang?: TLangType,
    domain?: string,
    inicialRequest: boolean = true
) => {
    const [askJarvisForMT, setAskJarvisForMT] = useState<string>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(false);

    const fetch = (
        thematicIdf?: number,
        langf?: TLangType,
        domainf?: string,
        handleMT?: (mt: string) => void
    ) => {
        if (!thematicIdf || !langf || !domainf) {
            setLoading(false);
            return;
        }
        setLoading(true);
        KeywordsTransport.AskjarvisForMT(thematicIdf, domainf, langf)
            .then((res) => {
                setAskJarvisForMT(res);
                if (handleMT) handleMT(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (
        thematicIdr?: number,
        langr?: TLangType,
        domainr?: string,
        handleMT?: (mt: string) => void
    ) => {
        if (!loading) fetch(thematicIdr, langr, domainr, handleMT);
    };

    useEffect(() => {
        if (inicialRequest) {
            fetch(thematicId, lang, domain);
        } else {
            setLoading(false);
        }
    }, [thematicId, lang, domain]);

    return { askJarvisForMT, loading, error, refresh };
};

export default useAskJarvisForMT;
